import { render, staticRenderFns } from "./SearchNavYearMonth.vue?vue&type=template&id=87c48e4e&scoped=true"
import script from "./SearchNavYearMonth.vue?vue&type=script&lang=js"
export * from "./SearchNavYearMonth.vue?vue&type=script&lang=js"
import style0 from "./SearchNavYearMonth.vue?vue&type=style&index=0&id=87c48e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c48e4e",
  null
  
)

export default component.exports